import React, {useEffect, useState} from 'react';
import * as Sentry from "@sentry/browser";
import {
  getAuth,
  isSignInWithEmailLink,
  signInWithEmailLink
} from "firebase/auth";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import Loading from "components/Loading";
import Header from "components/Header";
import {DESCRIPTION_CLASS, TEXT_INPUT_THEME, TITLE_CLASS} from "components/Survey/classes";
import {Button, TextInput} from "flowbite-react";
import clsx from "clsx";

const EmailLoginRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [initiated, setInitiated] = useState(false);
  const [started, setStarted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userEmail, setUserEmail] = useState<string | null>(window.localStorage.getItem('emailForSignIn'))
  const [formData, setFormData] = useState({
    email: '',
  });

  const auth = getAuth();
  const isSignInFlow = isSignInWithEmailLink(auth, window.location.href);

  const from = searchParams.get("from");

  useEffect(() => {
    setInitiated(true);
  }, []);

  useEffect(() => {
    if (!initiated) {
      return
    }
    if (started || userEmail === null || !isSignInFlow) {
      return;
    }
    setStarted(true);
    // The client SDK will parse the code from the link for you.
    signInWithEmailLink(auth, userEmail, window.location.href).then(() => {
      // Clear email from storage.
      window.localStorage.removeItem("emailForSignIn");
      navigate(from ? from : "/");
    })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
          Sentry.captureException(error);
          setLoading(false);
        });

  }, [navigate, started, initiated, isSignInFlow, auth, userEmail]);

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const {id, value} = event.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    setUserEmail(formData.email);
  }

  if (!isSignInFlow) {
    return <div>
      Invalid authentication token. <Link to="/login">Login</Link> to continue.
    </div>
  }

  if (userEmail === null) {
    return <>
      <Header saveFormCallback={null} hideSignIn />
      <div className={"flex flex-col"}>
        <div className="flex flex-col">
          <div className={"mt-32 flex flex-row justify-center"}>
            <span className={TITLE_CLASS}>Confirm your email address to sign in</span>
          </div>
          <div className={"mt-4 flex flex-row justify-center"}>
            <form className={"w-full max-w-screen-sm"} onSubmit={handleSubmit}>
              <div className="mb-6 w-full">
                <div className={clsx(DESCRIPTION_CLASS, "text-center")}>Email address</div>
                <TextInput
                    className={"w-full mt-4"}
                    theme={TEXT_INPUT_THEME}
                    sizing={"lg"}
                    type="email" id="email"
                    placeholder="john.doe@company.com"
                    required
                    value={formData.email} onChange={handleChange}
                />
              </div>
              <div className={"flex flex-row mt-8 justify-center"}>
                <Button
                    className={"min-w-24 ml-1 rounded-full"}
                    color={"blue"}
                    type={"submit"}
                >Sign In</Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>;
  }

  if (loading) {
    return <>
      <Header saveFormCallback={null} hideSignIn />
      <div className={"flex flex-col"}>
      <Loading className={"mt-24"} loadingText={"Logging you in ..."}/>
    </div>
      </>
        ;
  }
  return <div className={"flex flex-col"}>
    <Header saveFormCallback={null} />
    <div className={"mt-16 flex flex-row justify-center"}>
      There was an error trying to log you in.
      <br/>
      Try to <Link to="/login">login</Link> again to continue.
    </div>
  </div>;
}

export default EmailLoginRedirect;
